import { AppTextService } from '@fi-shared/app-text';
import { createMap } from '@fi-shared/utils/create-map';

export enum fiPaymentMethodType {
    Invoice = 1,
    CreditCard = 2,
}

export const fiPaymentMethodTypes = [
    {
        Id: fiPaymentMethodType.Invoice,
        TextId: 'common.invoice',
    },
    {
        Id: fiPaymentMethodType.CreditCard,
        TextId: 'common.credit_card',
    },
];

const fiPaymentMethodTypesMap = createMap(fiPaymentMethodTypes, 'Id');
export function fiPaymentMethodTypeName(paymentMethodType: fiPaymentMethodType, appText: AppTextService) {
    if (fiPaymentMethodTypesMap.hasOwnProperty(paymentMethodType))
        return appText.get(fiPaymentMethodTypesMap[paymentMethodType].TextId);

    throw 'FI: Unknown payment method ' + paymentMethodType;
}
